import { QueryClient } from "@tanstack/react-query";

export const storeQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // unkown options
      // cacheTime: 1000 * 60 * 60 * 12,
      staleTime: 1000 * 60 * 60,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: true,
      // retryAttempts: 1,
      // keepPreviousData: true,
      // enabled: process.env.NODE_ENV === 'development' ? false : true,
    },
  },
});
